import React from "react";
import {Button, LinearProgress, TextField} from "@material-ui/core";

const TMSearchHeader = ({wordmark, setWordmark, onSubmit, fetching}) => {
    return (
        <div className="relative w-full bg-white shadow p-4 flex flex-col pb-0">
            <h3 className="text-3xl">Trademark Search</h3>
            <p className="text-gray-500">Please enter a Brand Name to Search across all NICE/Trade Mark Classes</p>
            <div className="flex flex-row flex-1 mt-8 mb-8 space-x-2">
                <TextField
                    value={wordmark}
                    onChange={(e) => setWordmark(e.target.value)}
                    variant='outlined'
                    label='Brand Name'
                    className='w-full rounded-none flex-1 text-lg'
                    placeholder='Eg. Apple Pro'
                    onKeyDown={e => e.keyCode === 13 && onSubmit()}
                    InputLabelProps={{
                        shrink: true,
                    }}

                />
                <Button variant={"contained"}
                        color={"primary"}
                        onClick={onSubmit}
                        className="h-14 px-4">Search</Button>
            </div>
        </div>
    )
}

export default TMSearchHeader;